"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationModalForCp = NavigationModalForCp;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function NavigationModalForCp(_ref) {
  var src = _ref.src,
    show = _ref.show,
    onNavigationClose = _ref.onNavigationClose;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    show: show,
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-primary text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, "Navigation Panel")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: '100%'
    },
    src: src
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "light",
    type: "button",
    className: "shadow-none ",
    onClick: onNavigationClose
  }, "Close")));
}
var _default = NavigationModalForCp;
exports.default = _default;